import React, { Component } from 'react';
import ImageBoxContainer from './ImageBoxContainer';

class ImagesColumn extends Component {

	setupColumn(props) {
		return props.photos.map((photo, photoIndex) => {
			if ((photoIndex % this.props.totalCols.length) === props.colNum) {
				let photoUrl = photo.url;

				let isFavored = false;
				if (props.favoredPhotos) {
					for (var i = 0; i < props.favoredPhotos.length; i++) {
						if (props.favoredPhotos[i].url === photoUrl) {
							isFavored = true;
							break;
						}
					}
				}
				return (
					<div key={photoIndex}>
						<ImageBoxContainer src={photo.url} title={photo.title} favored={isFavored} disableFavs={props.disableFavs}></ImageBoxContainer>
					</div>
				)
			} else {
				return <div key={photoIndex}></div>;
			}
		});

	}

	render() {
	  if (this.colImages && this.colImages.length === 0) {
    	return null;
  	  }	else {
  	  	return (<div>
			{this.setupColumn(this.props)}
		</div>)
	  }
	}
}

export default ImagesColumn;



/** WEBPACK FOOTER **
 ** ./src/image-display/ImagesColumn.js
 **/